import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProviderUserUpdatePage = lazy(() => import('../views/update/ProviderUserUpdatePage'));

export function ProviderUserUpdatePageLazy() {
	return (
		<PageSuspense>
			<ProviderUserUpdatePage />
		</PageSuspense>
	);
}
